module.exports = __webpack_public_path__ + "static/media/hidden-person-bro.b09a0120.svg";